import React, { useState } from 'react'
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Modal } from 'antd';
import { Select } from 'antd';
import { Table } from 'antd';
import { DatePicker, Space } from 'antd'
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { RangePicker } = DatePicker;

const BudgetPlannerSOM = () => {
    const title = "Budget Planner SM SOM";
    const navigate = useNavigate();

    const _doNavToBudgetPlannerSM = () => {
        navigate("/BudgetPlannerSM");
    }
    
    const _doSelectVender = () => {

    }

    const TableData = [
        {
            key: '1',
            BudgetYear: "2021",
            BudgetCategory: "Prevent Maintaince",
            Status: "Pending"
        },
        {
            key: '2',
            BudgetYear: "2021",
            BudgetCategory: "Corrective Maintaince",
            Status: "Confirmed"
        },
        {
            key: '3',
            BudgetYear: "2021",
            BudgetCategory: "Annual Expense",
            Status: "Confirmed"
        }

    ]
    const TableColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i onClick={_doNavToBudgetPlannerSM} className="fa fa-eye orange"></i>
                        {
                        record.Status!="Confirmed" &&
                        <i onClick={_doNavToBudgetPlannerSM} className="fa fa-pencil blue"></i>}
                    </div>
                </Space>
            ),
        },
        {
            title: "Budget Year",
            dataIndex: "BudgetYear",
            key: "BudgetYear"
        },
        {
            title: "Budget Category",
            dataIndex: "BudgetCategory",
            key: "BudgetCategory"
        },
        {
            title: "Status",
            dataIndex: "Status",
            key: "Status"
        }

    ]
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
                <div className="m-btn-block">
                    <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div className="m-btn-block__btns">
                            <button type='submit' onClick={_doNavToBudgetPlannerSM} className='btn btn-secondary deca-btn-yellow'>Create Planner</button>
                        </div>
                    </div>
                </div>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="exampleInput">Status*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="2021">Pending</Option>
                                            <Option value="2022">Confirmed</Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type="button" className="btn btn-secondary btn-icon deca-btn-yellow"><i className="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width">
                                    <Table pagination={false} scroll={{y:300}} columns={TableColumns} dataSource={TableData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default BudgetPlannerSOM